import React from 'react';
import {
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText
  } from 'mdb-react-ui-kit';
import { FaCode } from 'react-icons/fa';
import { SiBmcsoftware, SiGnubash } from 'react-icons/si';
import { HiOutlineDesktopComputer } from 'react-icons/hi';
import vsc from '../assest/images/vsc.png';

const ExpertiesCard = ({icon, title, list}) => (
    <MDBCard className='bg-transparent border border-white experties-card'>
        <MDBCardBody>
            <MDBCardTitle className='heading4'>{icon} {title}</MDBCardTitle>
            <MDBCardText>
                <ul className='list-group'>
                    {list.map((li, i) => <li key={i} className='py-1 px-3 heading5 green'>{li}</li>)}
                </ul>
            </MDBCardText>
        </MDBCardBody>
    </MDBCard>
);

export default function Experties() {
    let myExperties = [{
        icon: <FaCode size={25} />,
        title: 'LANGUAGES',
        list: ['HTML', 'CSS/Sass', 'Javascript', 'Python', 'Java']
    }, {
        icon: <SiBmcsoftware size={25} />,
        title: 'FRAMEWORKS',
        list: ['React', 'VueJs', 'Node', 'Loopback.io', 'Express', 'Bootstrap', 'MDB', 'Material UI']
    }, {
        icon: <HiOutlineDesktopComputer size={25} />,
        title: 'TOOLS',
        list: ['Bash', 'Git, Github and Bitbucket', 'MongoDB', 'Mongodb Atlas Search', 'Jira']
    },{
        icon: <SiGnubash size={25} />,
        title: 'OTHERS',
        list: ['Redux', 'Linux', 'Mac', 'Windows', 'EBS', 'EC2', 'S3', 'Heroku']
    }]
  return (
    <div id='skill-container'>
        <h3 className='skills-title text-center p-4'>My Skills</h3>
        <div className='experties-container'>
            {myExperties.map((expert, i) => <ExpertiesCard key={i} {...expert} />)}
        </div>
        <div className='code-image'>
            <img src={vsc} alt='code' />
        </div>
    </div>
  )
}
